import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/clinic";
import { toast } from "sonner";
import { Loader2, Stethoscope, Check } from "lucide-react";

export const DoctorDialog = ({ open, onOpenChange, selezionato }) => {
  const [medici, setMedici] = useState([]);
  const [scelto, setScelto] = useState(selezionato || "");
  const [saving, setSaving] = useState(false);

  // Solo all'apertura: un cambio medico da un'altra postazione non deve azzerare la scelta in corso.
  useEffect(() => {
    if (!open) return;
    setScelto(selezionato || "");
    api.get("/medici").then(({ data }) => setMedici(data.medici)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const salva = async () => {
    if (!scelto) {
      toast.error("Seleziona il medico del lavoro di giornata");
      return;
    }
    setSaving(true);
    try {
      await api.put("/medici/selezionato", { nome: scelto });
      toast.success(`Medico di giornata: ${scelto}`);
      onOpenChange(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Impossibile salvare");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="doctor-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-tight">Medico del Lavoro di Giornata</DialogTitle>
          <DialogDescription className="text-sm text-slate-600">
            Il medico selezionato viene stampato in alto sul consenso, sopra la dicitura "Medicina del Lavoro".
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 max-h-[45vh] overflow-y-auto pr-1" data-testid="doctor-list">
          {medici.map((m) => {
            const active = scelto === m;
            return (
              <label
                key={m}
                onClick={() => setScelto(m)}
                data-testid={`doctor-option-${m.replace(/[^a-zA-Z]+/g, "-").toLowerCase()}`}
                className={`flex items-center gap-3 rounded-xl border p-3.5 cursor-pointer transition-colors ${
                  active ? "border-sky-500 bg-sky-50/70" : "border-slate-200 hover:border-slate-300"
                }`}
              >
                <Checkbox checked={active} onCheckedChange={() => setScelto(m)} />
                <span className="flex-1 font-display text-base font-semibold text-slate-900">{m}</span>
                {active && <Check className="w-4 h-4 text-sky-600" />}
              </label>
            );
          })}
        </div>

        <DialogFooter>
          <Button onClick={salva} disabled={saving} className="rounded-full px-6 w-full sm:w-auto" data-testid="doctor-save-btn">
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Stethoscope className="w-4 h-4 mr-2" />}
            Conferma medico
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
